import { useCallback, useEffect, useState } from "react";
import { RequestItem, fetchRequestList } from "../api/requests";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

interface UseRequestListOptions {
  page: number;
  pageSize: number;
  enabled?: boolean;
}

export const useRequestList = ({ page, pageSize, enabled = true }: UseRequestListOptions) => {
  const [data, setData] = useState<RequestItem[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const refetch = useCallback(() => {
    setReloadToken((token) => token + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchRequestList({
      queryString: "",
      page,
      pageSize,
      status: null,
      direction: "desc",
    })
      .then((items) => {
        if (!cancelled) {
          setData(items);
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(getApiErrorMessage(err, "Не удалось загрузить заявки"));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [page, pageSize, enabled, reloadToken]);

  return { data, loading, error, refetch };
};
